import {CtModelRouteData} from "@ctsolution/ct-framework";

export const UserWorkingHoursFileRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("UserWorkingHoursFile");
